import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { AxiosResponse } from 'axios';
import { Region } from 'shared/types';

import { persistedQueryClient } from 'components/CacheableQueryClientProvider';

const ONE_DAY = 1000 * 60 * 60 * 24;

type UseAllRegionsQueryProps = {
  retry?: boolean;
  enabled?: boolean;
};

const fetchAllRegions = (): Promise<AxiosResponse<Region[]>> =>
  API.get<Region[]>('regions/', { params: { no_filter: true } });

export const useAllRegionsQuery = (
  props: UseAllRegionsQueryProps,
): UseQueryResult<AxiosResponse<Region[]> | undefined> => {
  const { retry = false, enabled = false } = props;

  const query = useQuery(
    {
      queryKey: ['allRegions'],
      queryFn: fetchAllRegions,
      staleTime: 30 * ONE_DAY,
      gcTime: 30 * ONE_DAY,
      retry,
      enabled,
    },
    persistedQueryClient,
  );

  return query;
};
